<template>
  <!-- At least the window's height, taller when the content needs more; clips the oversized angled panel. -->
  <div class="position-relative d-flex min-vh-100 overflow-hidden">
    <div class="c-login__fore" />
    <div class="c-login__back">
      <div class="d-flex justify-content-end h-100 me-5 mt-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="838.524"
          height="967.122"
          viewBox="0 0 838.524 967.122"
          class="c-login__pear w-auto"
          aria-hidden="true"
          focusable="false"
        >
          <path
            id="BigPear"
            :d="BIG_PEAR_PATH"
            transform="translate(-61.127 0.05)"
            fill="#014d37"
            opacity="0.997"
          />
        </svg>
      </div>
    </div>
    <div class="c-login__container">
      <div class="c-login__signform">
        <div class="d-flex justify-content-center mb-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="196"
            height="64"
            aria-label="PEARS"
            role="img"
          >
            <title>PEARS</title>
            <path v-for="(p, i) in PEARS_LOGO_PATHS" :key="i" :fill="p.fill" :d="p.d" />
          </svg>
        </div>
        <slot />
        <!-- Narrow screens: a link at the bottom of the card. Wide screens use the forest-panel intro below instead. -->
        <div v-if="showIntro" class="c-login__card-intro border-top mt-4 pt-2 text-center">
          <a
            class="link-primary fw-medium fs-4 d-inline-block py-2"
            href="https://www.canopyteam.org/"
            target="_blank"
            rel="noopener"
            data-test="signin-what-is-pears-card"
          >
            What is PEARS?<i class="fa fa-arrow-right ms-2" aria-hidden="true" />
          </a>
        </div>
      </div>
      <aside v-if="showIntro" class="c-login__intro" aria-label="About PEARS">
        <p class="c-login__intro-title fs-9 fw-medium lh-sm text-white mb-3">
          Plan, track, and prove your program's impact.
        </p>
        <p class="c-login__intro-text fs-4 mb-4">
          Used by over 120 organizations, including 30+ land-grant universities, and growing!
        </p>
        <a
          class="btn btn-lg btn-default text-primary rounded-1"
          href="https://www.canopyteam.org/"
          target="_blank"
          rel="noopener"
          data-test="signin-what-is-pears"
        >
          What is PEARS?<i class="fa fa-arrow-right ms-2" aria-hidden="true" />
        </a>
      </aside>
      <footer class="c-login__footer text-body-secondary text-center mt-4">
        <small>
          &copy; {{ currentYear }} PEARS
          <span class="c-login__footer-divider" aria-hidden="true">·</span>
          <a class="c-login__footer-link" target="_blank" rel="noopener" href="https://canopyteam.org/">
            Canopy, a Public Benefit LLC
          </a>
          <span class="c-login__footer-divider" aria-hidden="true">·</span>
          <a class="c-login__footer-link" :href="urls.termsUrl">Terms of Use</a>
          <span class="c-login__footer-divider" aria-hidden="true">·</span>
          <a class="c-login__footer-link" :href="urls.privacyUrl">Privacy</a>
        </small>
      </footer>
    </div>
    <!-- Wide screens: links along the bottom of the page instead of under the card. -->
    <footer class="c-login__base-footer position-absolute z-2 bottom-0 w-100">
      <div class="float-end text-white pe-8">
        PEARS &copy; {{ currentYear }}
        <a target="_blank" rel="noopener" href="https://canopyteam.org/" class="text-white text-decoration-underline">
          Canopy, a Public Benefit LLC
        </a>
      </div>
      <ul class="list-inline ps-8">
        <li class="list-inline-item">
          <a :href="urls.termsUrl">Terms of Use</a>
        </li>
        <li class="list-inline-item">
          <a :href="urls.privacyUrl">Privacy</a>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script setup>
import {inject} from 'vue';
import {BIG_PEAR_PATH, PEARS_LOGO_PATHS} from './authBrandingSvg.js';

defineProps({
  // Shows the "What is PEARS?" intro for visitors who aren't customers yet. Only the sign-in view sets it.
  showIntro: {
    type: Boolean,
    default: false,
  },
});

const urls = inject('urls'),
      currentYear = new Date().getFullYear();
</script>
